exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity[data-v-0a6217b8]  .el-form-item__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.quantity[data-v-0a6217b8]  .el-form-item__content .el-input-number{-webkit-box-flex:1;-ms-flex:1;flex:1;margin-right:10px}.quantity[data-v-0a6217b8]  .el-form-item__content .info{color:#f56c6c}", ""]);

// exports
